import Color from '../Color/Color'
import Paragraph from '../Paragraph/Paragraph'
import classes from './FlashMessage.module.scss'
import { HiCheck } from 'react-icons/hi'
import { useEffect } from 'react'

export interface Props {
  label: string
  flashMessage: string
  isFlashing: boolean
  duration?: number
  onChange: (value: boolean) => void
}

const FlashMessage = ({
  label,
  flashMessage,
  isFlashing,
  duration = 3000,
  onChange
}: Props) => {
  useEffect(() => {
    if (isFlashing) {
      setTimeout(() => {
        onChange(false)
      }, duration)
    }
  })

  return (
    <Paragraph>
      {
        isFlashing
          ? (
            <div className={classes.FlashMessage}>
              <Color variant='green'>
                <HiCheck
                  aria-hidden
                  size={18}
                />
              </Color>
              <Paragraph>
                {flashMessage}
              </Paragraph>
            </div>
          )
          : (
            <Color variant='theme-color-readonly-field-text'>
              {label}
            </Color>
          )
      }
    </Paragraph>
  )
}

export default FlashMessage
